import { useNumericParams } from '@domain-group/react-hooks'

import useGeoStates from '@hooks/useGeoStates'
import useReduxAction from '@hooks/useReduxAction'

import type { ModuleState } from '@redux/modules/module'

import CampaignEditRoutes from './routes'

const CampaignEdit = () => {
  const { campaignId } = useNumericParams()

  useGeoStates({ performHttpRequests: true })

  useReduxAction(
    'campaigns',
    'loadCampaign',
    {
      entityId: campaignId,
      include_agency_image: true,
      include_agent_user: true,
      include_campaign_agency: true,
      include_campaign_agents: true,
      include_campaign_paths: true,
      include_campaign_team: true,
      include_image_sizes: true,
      include_team_member_user: true,
      include_team_members: true,
      include_user_image: true,
    },
    [campaignId],
    {
      dispatchAction: (action, requestOptions) => action(campaignId, requestOptions),
      shouldPerformFn: ({ loading }: ModuleState) => !!campaignId && !loading,
    },
  )

  return (
    <CampaignEditRoutes />
  )
}

export default CampaignEdit
